import { commodityOptions } from 'data';
import React from 'react';

const Commodities = ({ commodities }) => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <h2 className="text-2xl font-bold text-red-500 text-center mb-2">
        Commodities Hauled
      </h2>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#666666] text-white font-bold">
              <th className="px-4 py-2 text-left">Commodity Type</th>
              <th className="px-4 py-2 text-right">% of Hauls</th>
            </tr>
          </thead>
          <tbody>
            {commodities?.map((commodity, index) => (
              <tr
                key={index}
                className={
                  index % 2 === 0
                    ? 'bg-white text-sm'
                    : 'bg-gray-50 text-sm'
                }
              >
                <td className="px-4 py-2 text-left font-bold">
                  {
                    commodityOptions?.find(
                      (cmodt) =>
                        cmodt.value === commodity.commodityKey
                    )?.label
                  }
                </td>
                <td className="px-4 py-2 text-right">
                  {commodity.commodityPercentage} %
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Commodities;
